export var FIRST_NAME_ERROR='Please enter a first name';export var LAST_NAME_ERROR='Please enter a last name';
//# sourceMappingURL=optInErrors.js.map